
import { type ReactNode, useEffect, useState } from "react";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

export const PostHogAnalyticsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    posthog.init("phc_kq0AcfURYsfl8mjFRpPwww9M1HC1taAQms9wLNDW26k", {
      api_host:
        window.location.hostname === "localhost"
          ? undefined
          : "https://app.posthog.com",
      capture_pageview: true,
      autocapture: true,
    });
    setInitialized(true)
  }, [setInitialized]);

  // Render nothing until PostHog is initialized to prevent errors
  if (!initialized) return null;
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};
